import { colors } from '../../maps/colors';
import Btn from '../Btn';
import { useState } from 'react';
import AddProductToPlanograma from '../AddProductToPlanograma';
import IconBtn from '../IconBtn';
import SensorStatus from "../SensorStatus";
import useZibi from "../../zibi/UseZibi";
import styled from "styled-components";
import Icn from "../Icn";
import ProductItem from './ProductItem';
import styles from './FieldShelf.module.css';

const CameraMenuStyled = styled.div`
  position: absolute;
  bottom: 28px;
  color: #000;
  font-weight: 400;
  font-size: 12px;
  width: max-content;

  background-color: rgb(255, 255, 255);
  border-radius: 6px;
  box-shadow: rgba(145, 158, 171, 0.2) 0 5px 5px -3px, rgba(145, 158, 171, 0.14) 0px 8px 10px 1px, rgba(145, 158, 171, 0.12) 0px 3px 14px 2px;
  transition: opacity 230ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 153ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  padding: 10px;
  right: 0;
  max-height: 100px;
  overflow: auto;
`;

const CameraMenuItemStyled = styled.div`
  line-height: 1.4;
  cursor: pointer;
  padding: 4px;
  border-radius: 2px;

  display: grid;
  grid-template-columns: 19px auto;
  white-space: nowrap;
  gap: 3px;

  &:hover {
    background-color: rgba(145, 158, 171, 0.08);
  }
`;

const WrapperStyled = styled.div`

  .field-icon-arrow {
    :hover {
      
    }
  }
`;

export default function FieldShelf(props) {

  const { onPlanogramChange, card_view, onDeleteShelf, hasCamera, cameras, order, nextOrder, changeOrder, width, sensor, isPlanogramValid } = props;
  const [planogram, s_planogram] = useState(props.planogram || []);
  const [open_products_dialog, s_open_products_dialog] = useState(false);
  const [hover, s_hover] = useState(-1);
  const [blink, s_blink] = useState(false);
  const [hover_shelf_name, s_hover_shelf_name] = useState(false);
  const [showCameraMenu, s_showCameraMenu] = useState(false);
  const [sensorStatuses] = useZibi('sensorStatuses');
  const sensorStatusData = sensorStatuses[props.sensorId];

  const status = sensorStatusData?.status;
  const statusUpdateAt = sensorStatusData?.statusUpdateAt;

  const addProduct = product => {
    const _planogram = planogram.concat({
      productId: product._id,
      product
    });
    s_planogram(_planogram);
    onPlanogramChange(_planogram);
  };

  const remove = idx => {
    let _planogram = planogram.concat();
    _planogram.splice(idx, 1);
    s_planogram(_planogram);
    onPlanogramChange(_planogram);
  };

  const left = idx => {
    let _planogram = planogram.concat();
    const product = _planogram[idx];
    _planogram.splice(idx, 1);
    _planogram.splice(idx - 1, 0, product);
    s_planogram(_planogram);
    onPlanogramChange(_planogram);
  };

  const right = idx => {
    let _planogram = planogram.concat();
    const product = _planogram[idx];
    _planogram.splice(idx, 1);
    _planogram.splice(idx + 1, 0, product);
    s_planogram(_planogram);
    onPlanogramChange(_planogram);
  };

  const isPlanogramValidBool = isPlanogramValid === true;

  return (
    <WrapperStyled style={{
      width: '100%',
      border: `1px solid ${colors.GRAY1}`,
      marginBottom: card_view ? 0 : 10,
      borderRadius: 5,
      position: "relative"
    }}>
      <SensorStatus status={status} statusUpdateAt={statusUpdateAt} size={7} />
      <div style={{ flexDirection: 'row', display: 'flex' }}>
        {planogram.map(p => (
          <ProductItem
            key={p._id}
            product={p.product}
            isCardView={card_view}
            shelfPercentage={p.percentage}
            length={planogram.length}
            fullWidth={width}
          />
        ))}
      </div>

      {!card_view && (
        <div style={{ background: '#ddd', fontSize: 8, textAlign: 'center' }}>
          ← {width} cm / 100% →
        </div>
      )}

      <div
        onMouseEnter={() => s_hover_shelf_name(true)}
        onMouseLeave={() => s_hover_shelf_name(false)}
        className={isPlanogramValidBool ? styles["planograma-valid"] : styles.blink}
        style={{
          padding: card_view ? '0px 5px' : '2px 30px',
          position: 'relative',
          color: 'white',
          fontWeight: 'bold',
          textAlign: 'left',
          fontSize: card_view ? 8 : 14
        }}>

        {props.sensor?.boardId}
        {props.sensor?.type === 3 && (
          <span style={{ color: colors.PINK, fontSize: 11, marginLeft: 4 }}>W</span>
        )}
        {!isPlanogramValidBool ? ` [Polanograma Alert]` : <></>}
        {
          !card_view && hover_shelf_name && onDeleteShelf && <Btn customtheme="normal" style={{
            position: 'absolute',
            border: 'none',
            color: colors.LIGHT_ORANGE,
            left: 0,
            top: -1,
            background: 'none',
            padding: "2px 10px"
          }} startIcon="delete" onClick={onDeleteShelf}></Btn>
        }

        {
          !card_view && nextOrder && <IconBtn style={{
            position: 'absolute',
            border: "0 solid snow",
            color: colors.LIGHT_ORANGE,
            right: 170,
            top: 0,
            background: 'none',
            padding: "0 1px"
          }} startIcon="product" onClick={() => changeOrder(props._id)}>arrowDown</IconBtn>
        }


        {
          !card_view && order !== 1 && <IconBtn
            classes={"field-icon-arrow"}
            style={{
              position: 'absolute',
              border: "0 solid snow",
              color: colors.LIGHT_ORANGE,
              right: 140,
              top: 0,
              background: 'none',
              padding: "0 1px"
            }} startIcon="product" onClick={() => changeOrder(props._id, true)}>arrowUp</IconBtn>
        }

        {/* {
          !card_view && <Btn customtheme="normal" style={{
            position: 'absolute',
            border: 'none',
            color: colors.LIGHT_ORANGE,
            right: 70,
            top: -1,
            background: 'none',
            padding: "2px 10px"
          }} startIcon="product" onClick={() => s_open_products_dialog(true)}></Btn>
        } */}
        {
          !card_view && hasCamera && <Btn customtheme="normal" style={{
            position: 'absolute',
            border: 'none',
            color: colors.LIGHT_ORANGE,
            right: -1,
            top: 0,
            background: 'none',
            padding: "2px 10px"
          }} startIcon="draw" onClick={() => {
            s_showCameraMenu(!showCameraMenu);
          }}>
            {showCameraMenu && (
              <CameraMenuStyled>
                {cameras.map((cam, idx) => {
                  return (
                    <CameraMenuItemStyled
                      key={cam._id + idx}
                      onClick={() => {
                        s_showCameraMenu(false);
                        if (props.drawBoundingBox) {
                          props.drawBoundingBox(props._id, props.shelfIndex, cam._id);
                        }
                      }}
                    >
                      <Icn style={{ color: 'black', fontSize: 16 }}>camera</Icn> {cam.name}
                    </CameraMenuItemStyled>
                  );
                })}
              </CameraMenuStyled>
            )}
          </Btn>
        }
      </div>

      {
        open_products_dialog && <AddProductToPlanograma onSelect={product => {
          s_open_products_dialog(false);
          addProduct(product);
        }} open={open_products_dialog} onClose={() => s_open_products_dialog(false)} />
      }
    </WrapperStyled>
  );
}